"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlardarInitializer = exports.useInitSlardar = exports.SlardarStaticScript = exports.SlardarDeferredScript = exports.SlardarScript = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const jotai_1 = require("jotai");
const react_1 = require("react");
const atom_1 = require("../../atom");
const constant_1 = require("./constant");
const ssr_1 = require("../../ssr");
/**
 * @see https://bytedance.feishu.cn/wiki/wikcnswjRW7cuCJJ4rZSwh7aKdg
 * @see https://bnpm.bytedance.net/package/@slardar/web
 */
const SLARDAR_CDN = constant_1.SlardarSDKUrlMap[__BUILD_REGION__];
// modifed: remove the logic for creating dom element
const content = `
;(function (w, d, u, b, n, pc, ga, ae, po, s, p, e, t, pp) {pc = 'precollect';ga
= 'getAttribute';ae = 'addEventListener';po = 'PerformanceObserver';s = function
(m) {p = [].slice.call(arguments);p.push(Date.now(), location.href);(m == pc ?
s.p.a : s.q).push(p)};s.q = [];s.p = { a: [] };w[n] = s;if (ae in w)
{s.pcErr = function (e) {e = e || w.event;t = e.target || e.srcElement;if (t
instanceof Element || t instanceof HTMLElement) {if (t[ga]('integrity'))
{w[n](pc, 'sri', t[ga]('href') || t[ga]('src'))} else {w[n](pc, 'st', { tagName:
t.tagName, url: t[ga]('href') || t[ga]('src') })}} else {w[n](pc, 'err', e.error)}};s.pcRej = function (e) {e = e || w.event;w[n](pc, 'reject',
e.reason || (e.detail && e.detail.reason))};w[ae]('error', s.pcErr,
true);w[ae]('unhandledrejection', s.pcRej,
true);};if('PerformanceLongTaskTiming' in w) {pp = s.pp = { entries: []
};pp.observer = new PerformanceObserver(function (l) {pp.entries =
pp.entries.concat(l.getEntries())});pp.observer.observe({ entryTypes:
['longtask', 'largest-contentful-paint','layout-shift']
})}})(window,document,'${SLARDAR_CDN}','${constant_1.BID}','${constant_1.NAME}')
`;
const SlardarScript = ({ pageview, integrations }) => {
    const { webId } = (0, jotai_1.useAtomValue)(atom_1.$WebUser);
    const { disableInlineScripts } = (0, jotai_1.useAtomValue)(atom_1.$RenderConfig);
    const additionalScripts = (0, jotai_1.useAtomValue)(atom_1.$AdditionalScripts);
    (0, react_1.useMemo)(() => {
        if (__BUILD_TARGET__ === 'server') {
            return;
        }
        const { Slardar } = window;
        Slardar('init', {
            bid: constant_1.BID,
            userId: webId,
            domain: constant_1.SlardarReportDomain[__BUILD_REGION__],
            env: __BUILD_TYPE__,
            release: __BUILD_VERSION__,
            pluginPathPrefix: constant_1.SlardarPluginPathPrefix[__BUILD_REGION__],
            plugins: {
                blankScreen: true,
                action: true,
                pageview,
                fmp: {
                    renderType: 'SSR',
                },
            },
            integrations,
        });
        Slardar('start');
    }, []);
    if (disableInlineScripts) {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("script", { id: "slardar-config", type: "application/json", dangerouslySetInnerHTML: {
                        __html: JSON.stringify({
                            SLARDAR_CDN,
                        }),
                    } }), (0, jsx_runtime_1.jsx)("script", { id: "slardar-script", src: additionalScripts['slardar-precollect'] })] }));
    }
    return (0, jsx_runtime_1.jsx)("script", { id: "slardar-script", dangerouslySetInnerHTML: { __html: content } });
};
exports.SlardarScript = SlardarScript;
const SlardarDeferredScript = () => {
    return (0, jsx_runtime_1.jsx)("script", { id: "slardar-script-defer", defer: true, src: `${SLARDAR_CDN}?bid=${constant_1.BID}&globalName=${constant_1.NAME}` });
};
exports.SlardarDeferredScript = SlardarDeferredScript;
const SlardarStaticScript = () => {
    const { disableInlineScripts } = (0, jotai_1.useAtomValue)(atom_1.$RenderConfig);
    const additionalScripts = (0, jotai_1.useAtomValue)(atom_1.$AdditionalScripts);
    return ((0, jsx_runtime_1.jsxs)(ssr_1.StaticHead, { children: [disableInlineScripts ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("script", { id: "slardar-config", type: "application/json", dangerouslySetInnerHTML: {
                            __html: JSON.stringify({
                                SLARDAR_CDN,
                            }),
                        } }), (0, jsx_runtime_1.jsx)("script", { id: "slardar-script", src: additionalScripts['slardar-precollect'] })] })) : ((0, jsx_runtime_1.jsx)("script", { id: "slardar-script", dangerouslySetInnerHTML: { __html: content } })), (0, jsx_runtime_1.jsx)("script", { id: "slardar-script-defer", defer: true, src: `${SLARDAR_CDN}?bid=${constant_1.BID}&globalName=${constant_1.NAME}` })] }));
};
exports.SlardarStaticScript = SlardarStaticScript;
const useInitSlardar = (props) => {
    const { pageview, integrations } = props;
    const { webId } = (0, jotai_1.useAtomValue)(atom_1.$WebUser);
    (0, react_1.useMemo)(() => {
        if (__BUILD_TARGET__ === 'server') {
            return;
        }
        const { Slardar } = window;
        Slardar('init', {
            bid: constant_1.BID,
            userId: webId,
            domain: constant_1.SlardarReportDomain[__BUILD_REGION__],
            env: __BUILD_TYPE__,
            release: __BUILD_VERSION__,
            pluginPathPrefix: constant_1.SlardarPluginPathPrefix[__BUILD_REGION__],
            plugins: {
                blankScreen: true,
                action: true,
                pageview,
                fmp: {
                    renderType: 'SSR',
                },
            },
            integrations,
        });
        Slardar('start');
    }, []);
};
exports.useInitSlardar = useInitSlardar;
const SlardarInitializer = (props) => {
    const { pageview, integrations } = props;
    const { webId } = (0, jotai_1.useAtomValue)(atom_1.$WebUser);
    (0, react_1.useMemo)(() => {
        if (__BUILD_TARGET__ === 'server') {
            return;
        }
        const { Slardar } = window;
        Slardar('init', {
            bid: constant_1.BID,
            userId: webId,
            domain: constant_1.SlardarReportDomain[__BUILD_REGION__],
            env: __BUILD_TYPE__,
            release: __BUILD_VERSION__,
            pluginPathPrefix: constant_1.SlardarPluginPathPrefix[__BUILD_REGION__],
            plugins: {
                blankScreen: true,
                action: true,
                pageview,
                fmp: {
                    renderType: 'SSR',
                },
            },
            integrations,
        });
        Slardar('start');
    }, []);
    return null;
};
exports.SlardarInitializer = SlardarInitializer;
